import React from 'react';
import styled from 'styled-components';
import { TRIAGE_HIGH_NEED_ACTIVE_COLOR, TRIAGE_HIGH_NEED_MARKER_COLOR } from './constants';

/**
 * The Complex Needs pill, shared by the Flagged Concerns header and the detail modal's
 * identity block. Colors mirror the triage matrix's High Need cell and marker.
 */
export const ComplexNeedsPill = ({ className }: { className?: string }) => (
  <PillSpan className={className}>Complex Needs</PillSpan>
);

const PillSpan = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 2px 18px;
  border: 1px solid ${TRIAGE_HIGH_NEED_MARKER_COLOR};
  border-radius: 20px;
  background-color: ${TRIAGE_HIGH_NEED_ACTIVE_COLOR};
  color: ${TRIAGE_HIGH_NEED_MARKER_COLOR};
  font-size: 14px;
  font-weight: 900;
  text-transform: uppercase;
  white-space: nowrap;
`;
